import React, { Component } from "react";

import TextareaAutosize from "react-textarea-autosize";

import UserImage from "../user_image";

import LocalizedStrings from "react-localization";
import en from "../../localization/localization-en.json";

let strings = new LocalizedStrings({ en });

class CreateListUser extends Component {
  state = {};
  render() {
    return (
      <div className="question_answer_v2 pb-3 pt-3">
        <div className="image-profile center pt-3">
          <UserImage user={this.props.user} link={this.props.link} />
        </div>
        <label className="name">
          {this.props.user.first_name} {this.props.user.last_name}
        </label>
        <label className="username">{this.props.user.username}</label>
        <div className="question_v2" style={{ paddingBottom: "10px" }}>
          <TextareaAutosize
            placeholder="TITLE"
            type="text"
            className="question_title_v2 center"
            onChange={this.props.handleChangeTitle}
            value={this.props.listTitle}
            style={{
              width: "95%",
              backgroundColor: "transparent",
              border: "none"
            }}
          />
        </div>
        <label
          className="number_questions pb-2"
          onClick={this.props.handleChangeSeachToList}
          style={{ cursor: "pointer" }}
        >
          {this.props.questionsSelected.length} {strings.questions}
        </label>
      </div>
    );
  }
}

export default CreateListUser;



// WEBPACK FOOTER //
// ./src/components/create_list/create_list_user.jsx